import React, { useEffect, useState } from 'react';
import Loader from '../Loader';
import axios from 'axios';

// getform.io
const API_KEY = process.env.REACT_APP_API_KEY;

const Appointment = (props) => {
    const { loading, data } = props;
    const [consult, setConsult] = useState([]);
    const [currentConsult, setCurrentConsult] = useState('');
    const [filteredConsult, setFilteredConsult] = useState([]);
    const [inputs, setInputSelect] = useState({});
    const [expirationDate, setExpirationDate] = useState(new Date());
    const [activeState, setActiveState] = useState(false);

    const [serverState, setServerState] = useState({
        submitting: false,
        status: null,
    });

    const handleServerResponse = (ok, msg, form) => {
        setServerState({
            submitting: false,
            status: { ok, msg },
        });
        if (ok) {
            form.reset();
        }
    };

    useEffect(() => {
        setConsult(data);

        if (currentConsult === 'consult_business') {
            setFilteredConsult(consult.consult_business);
        }
        if (currentConsult === 'consult_strategy') {
            setFilteredConsult(consult.consult_strategy);
        }
    });

    useEffect(() => {
        setExpirationDate(new Date());
    }, []);

    const onHandleChange = (e) => {
        e.persist();

        if (e.target.value.length === 0) {
            return;
        }
        setCurrentConsult(e.target.value);

        setInputSelect((inputs) => ({
            ...inputs,
            [e.target.name]: e.target.value,
        }));

        // set form to visible if radiocheck is interacted.
        if (e.target.type === 'radio') {
            setActiveState(true);
        }

        // reset fields if consult-type is changed.
        if (e.target.name === 'consult' && e.target.value === '') {
            setInputSelect({});
            setActiveState(false);
        }
    };

    const onhandleSubmit = (event) => {
        event.preventDefault();
        const form = event.target;

        setServerState({ submitting: true });
        axios
            .post(`https://getform.io/f/${API_KEY}`, inputs, {
                headers: {
                    Accept: 'application/json',
                },
            })
            .then((r) => {
                handleServerResponse(
                    true,
                    'Your request has been sent successfully. We will contact you soon!',
                    form
                );
            })
            .catch((r) => {
                handleServerResponse(false, r.response.data.error, form);
            });
    };

    // callback compares current server date with list date from ACF
    const checkExpiration = (date) => {
        return expirationDate > new Date(date);
    };

    const renderConsults = filteredConsult.length ? (
        filteredConsult.map((value, i) => {
            const {
                consult__date: date,
                consult__time: time,
                consult__availlability: is_available,
                consult__users: advisors,
            } = value;

            // define expiration date based on actual server date
            /* eslint-disable */
            if (checkExpiration(date) && is_available) {
                return;
            }
            /* eslint-enable */

            return (
                <div key={i} className="consult__results form-group">
                    <div>
                        {is_available && (
                            <label htmlFor={date} className="checkcontainer">
                                <div className="consult__results--date">
                                    <input
                                        type="radio"
                                        id={date}
                                        name="appointment"
                                        value={date}
                                        onChange={onHandleChange}
                                        required
                                        checked={
                                            inputs.appointment === date
                                                ? true
                                                : false
                                        }
                                    />
                                    <span className="checkmark"></span>
                                    <span>{date}</span>
                                    &nbsp; &ndash; &nbsp;
                                    <span>{time}</span>
                                </div>
                            </label>
                        )}
                        <div className="consult__results--advisors">
                            {inputs.appointment === date && (
                                <h3>Who is Available</h3>
                            )}
                            <div className="consult__container">
                                {advisors.map((user, i) => {
                                    return (
                                        <article
                                            className={`consult__results--advisor ${
                                                inputs.appointment === date
                                                    ? 'active'
                                                    : ''
                                            }`}
                                            key={i}>
                                            <div
                                                className="consult__results--avatar"
                                                dangerouslySetInnerHTML={{
                                                    __html: user
                                                        .consultation_user_item
                                                        .user_avatar,
                                                }}></div>
                                            <h4>
                                                {
                                                    user.consultation_user_item
                                                        .nickname
                                                }
                                            </h4>
                                        </article>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            );
        })
    ) : (
        <p className="consult__message--error">
            Sorry, no dates to show here yet.
        </p>
    );

    return (
        <form className="consult" onSubmit={onhandleSubmit} autoComplete="off">
            <header className="consult__header">
                <div className="two-col">
                    <h1>Call me back</h1>
                    <h2 className="consult__subtitle">
                        For a <br />
                        consult
                    </h2>
                </div>
                <div className="two-col">
                    <p className="intro">
                        Times change, which demands a lot from your
                        adaptability. Do you need advice or creative thinking?
                        Book a session, free of charge! That’s what friends are
                        for.
                    </p>
                </div>
            </header>

            {/* <div className="consult__select form-group styled-select">
                <select
                    className="form-control"
                    id="consult"
                    required="required"
                    name="consult"
                    onChange={onHandleChange}>
                    <option value="">Choose consult</option>
                    <option value="consult_business">Business advice</option>
                    <option value="consult_strategy">Strategy advice</option>
                </select>
                <span className="icon-arrow_right fa-sort-desc"></span>
            </div> */}
            <div className="consult__meetingplanner form-group">
                {loading !== true && <Loader></Loader>}
                {currentConsult !== '' && <h3>Plan a meeting</h3>}
                {currentConsult !== '' && renderConsults}
            </div>

            {currentConsult !== '' && (
                <div
                    className={`consult__contactform ${
                        activeState ? 'consult__contactform--active' : ''
                    }`}>
                    <div className="consult__details">
                        <h3>Your details</h3>
                        <div className="form-group">
                            <input
                                type="text"
                                className="form-control"
                                id="name"
                                placeholder="Name"
                                required="required"
                                name="name"
                                onChange={onHandleChange}
                            />
                        </div>
                        <div className="form-group">
                            <input
                                type="text"
                                className="form-control"
                                id="organisation"
                                placeholder="Organisation"
                                required="required"
                                name="organisation"
                                onChange={onHandleChange}
                            />
                        </div>
                        <div className="form-group">
                            <input
                                type="website"
                                className="form-control"
                                id="website"
                                placeholder="Website"
                                name="website"
                                onChange={onHandleChange}
                                required="required"
                            />
                        </div>
                        <div className="form-group">
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                minLength="3"
                                placeholder="E-mail"
                                name="email"
                                onChange={onHandleChange}
                                required="required"
                            />
                        </div>
                        <div className="form-group">
                            <input
                                type="tel"
                                className="form-control"
                                id="tel"
                                placeholder="Phone"
                                name="tel"
                                onChange={onHandleChange}
                                required="required"
                            />
                        </div>
                    </div>
                    <div className="consult__optional">
                        <div className="form-group">
                            <h3>
                                Which conference platform do you
                                prefer?(optional)
                            </h3>
                            <div className="styled-select">
                                <select
                                    className="form-control"
                                    id="platform"
                                    name="platform"
                                    onChange={onHandleChange}>
                                    <option>
                                        Choose your prefered platform
                                    </option>
                                    <option>Zoom</option>
                                    <option>Skype</option>
                                </select>
                                <span className="icon-arrow_right fa-sort-desc"></span>
                            </div>
                        </div>
                    </div>
                    <div className="form-group mt-3">
                        <button
                            type="submit"
                            className="cta-btn black consult__btn"
                            disabled={serverState.submitting}>
                            Schedule appointment
                        </button>
                        {serverState.status && (
                            <p
                                className={
                                    !serverState.status.ok
                                        ? 'consult__message--error'
                                        : 'consult__message'
                                }>
                                {serverState.status.msg}
                            </p>
                        )}
                    </div>
                    <br></br>
                </div>
            )}
        </form>
    );
};

export default Appointment;



// WEBPACK FOOTER //
// ./src/components/Forms/Appointment.jsx